import { instance } from '@/services/avik-api-gateway'
import { StatusActiveProposal } from '@/types/status-active-proposal'
import { AxiosResponse } from 'axios'

export function getActiveProposals(): Promise<
  AxiosResponse<StatusActiveProposal>
> {
  return instance.get(`/status/proposal`)
}
